<script>
  import { skills, res } from "../utils/addon.js";
  import SkillCard from "../components/skillCard.svelte";
  import { fade, slide } from "svelte/transition";
  let skillOption = "tech";
</script>

<main>
  <!-- 1st row -->
  <div
    class="flex flex-wrap justify-center items-center mx-auto md:space-x-16 md:space-y-0 space-y-4"
  >
    <div class="w-64">
      <img
        src="/assets/images/Profile_pic.jpg"
        alt="profile"
        class="w-full rounded-md"
      />
    </div>
    <div
      class="flex justify-center items-center flex-col md:w-1/2 text-center space-y-2"
    >
      <h1 class="text-4xl font-thin">
        About <span class="font-bold">Me</span>
      </h1>
      <p class="md:px-0 px-4">
        Hi, I'm Azharuddin Mohammed, and I'm a frontend developer at Quin Design.
      </p>
      <p class="md:px-0 px-4">
        I love photography.
      </p>

      <div class="py-4">
        <button>
          <a class="btn rounded-full bg-blue-500 text-white px-10" href="/assets/pdf/resume.pdf"
            >Download Resume</a
          >
        </button>
      </div>
    </div>
  </div>

  <!-- 2nd row -->

  <div class="">
    <div>
      <h1 class="text-center py-4 text-3xl font-medium">Skills</h1>
    </div>
    <div class="flex md:space-x-8 space-x-4 justify-center items-center">
      <button
        class={skillOption === "tech"
          ? "text-blue-400 text-lg p-2 rounded-sm font-medium"
          : "text-white text-lg p-2 rounded-sm font-medium"}
        on:click={() => {
          skillOption = "tech";
        }}>Tech</button
      >
      <button
        class={skillOption === "tools"
          ? "text-blue-400 text-lg p-2 rounded-sm font-medium "
          : "text-white text-lg p-2 rounded-sm font-medium "}
        on:click={() => {
          skillOption = "tools";
        }}>Tools</button
      >
      <button
        class={skillOption === "platforms"
          ? "text-blue-400 text-lg p-2 rounded-sm font-medium "
          : "text-white text-lg p-2 rounded-sm font-medium "}
        on:click={() => {
          skillOption = "platforms";
        }}>Platforms</button
      >
      <button
        class={skillOption === "management"
          ? "text-blue-400 text-lg p-2 rounded-sm font-medium"
          : "text-white text-lg p-2 rounded-sm font-medium"}
        on:click={() => {
          skillOption = "management";
        }}>Management</button
      >
    </div>
    <div>
      <div
        transition:fade={{ delay:300, duration: 1000 }}
        class="flex flex-wrap justify-center items-center md:w-3/4 w-full mx-auto transition-all"
      >
        {#each skills[skillOption] as skill}
          <SkillCard {...skill} />
        {/each}
      </div>
    </div>
  </div>
</main>
